import { track } from '../helpers/track'

// FAQ recrutement — lève les objections avant le formulaire. Uniquement des
// faits déjà revendiqués ailleurs sur le site (salaire, Ordre, logement,
// français) : rien de nouveau à tenir, tout est cohérent.
const FAQ = (isEnglish) => [
    {
        q: isEnglish ? 'How much will I really earn?' : 'Quel salaire vais-je vraiment gagner ?',
        a: isEnglish
            ? 'You keep 30%+ of the revenue you generate, with a guaranteed minimum of €3,000 gross/month. In practice our dentists earn €6,000–20,000 NET/month and orthodontists €8,000–20,000 NET/month, with a full schedule from day one. Use the calculator above for your own situation.'
            : "Vous touchez 30 % et plus des revenus que vous générez, avec un minimum garanti de 3 000 € brut/mois. En pratique, nos dentistes gagnent 6 000 à 20 000 € NETS/mois et les orthodontistes 8 000 à 20 000 € NETS/mois, avec un planning rempli dès le premier jour. Le calculateur ci-dessus vous donne votre cas précis.",
    },
    {
        q: isEnglish ? "I'm a foreign dentist — can I practice in France?" : 'Je suis dentiste étranger : puis-je exercer en France ?',
        a: isEnglish
            ? 'Yes, with EU citizenship and a dental degree from an EU university. We handle the registration with the French dental council (Ordre) with you — about 2 months, and we gather all the documents.'
            : "Oui, avec la citoyenneté européenne et un diplôme d'une université de l'UE. Nous gérons avec vous l'inscription au conseil de l'Ordre — environ 2 mois, et nous rassemblons tous les documents nécessaires.",
    },
    {
        q: isEnglish ? "I don't speak French (yet)" : 'Je ne parle pas (encore) français',
        a: isEnglish
            ? "That's expected. We recommend weekly lessons for about 3 months before the move, then we run a 20-hour bootcamp with a French teacher right before your interview with the dental council — targeted preparation included. Many of our practitioners started exactly there."
            : "C'est prévu. Nous recommandons des cours hebdomadaires pendant environ 3 mois avant l'arrivée, puis nous organisons un bootcamp de 20 h avec une professeure de français juste avant l'entretien à l'Ordre, avec une préparation ciblée. Plusieurs de nos praticiens sont passés exactement par là.",
    },
    {
        q: isEnglish ? 'How does the relocation work?' : "Comment se passe l'installation ?",
        a: isEnglish
            ? 'Housing is provided for your first 3 months after relocating, and we help with the admin: bank account, tax registration, schools for the kids. You start with peace of mind.'
            : "Le logement est offert les 3 premiers mois à l'installation, et nous vous aidons pour les formalités : compte bancaire, fiscalité, école des enfants. Vous démarrez l'esprit tranquille.",
    },
    {
        q: isEnglish ? 'What are the working conditions?' : 'Quelles conditions de travail ?',
        a: isEnglish
            ? '4-day work week from 9 to 6, 6 weeks of holidays, a dedicated assistant, zero admin work and zero restrictive contract clauses. You do dentistry, we do the rest.'
            : '4 jours par semaine de travail, de 9 h à 18 h, 6 semaines de congés, une assistante dédiée, zéro administratif et zéro clause restrictive au contrat. Vous faites de la dentisterie, on s\'occupe du reste.',
    },
    {
        q: isEnglish ? 'Where are the clinics?' : 'Où sont les cabinets ?',
        a: isEnglish
            ? 'Châteauroux, Déols and Saint-Maur, in the Indre — 2h south of Paris. Three modern clinics, 11 treatment rooms, rated 4.8/5 by patients on Google.'
            : "À Châteauroux, Déols et Saint-Maur, dans l'Indre — à 2 h au sud de Paris. Trois cabinets modernes, 11 salles de soins, notés 4,8/5 par les patients sur Google.",
    },
]

export default function Faq({ isEnglish }) {
    return (
        <div className="px-4 sm:px-32 mt-14 sm:mt-24">
            <div className="bg-white py-8 sm:py-12 px-4 sm:px-10 rounded-xl shadow-xl">
                <h3 className="text-md md:text-xl font-semibold leading-7 text-brand-600 text-center">FAQ</h3>
                <h2 className="mb-6 md:mb-10 md:mt-1 text-2xl sm:text-3xl font-bold md:text-4xl tracking-tight text-gray-900 text-center">
                    {isEnglish ? 'Your questions, answered' : 'Vos questions, nos réponses'}
                </h2>
                <div className="max-w-3xl mx-auto divide-y divide-gray-100">
                    {FAQ(isEnglish).map((item) => (
                        <details
                            key={item.q}
                            className="group py-4"
                            onToggle={(e) => { if (e.target.open) track('faq_open', { question: item.q }) }}
                        >
                            <summary className="flex cursor-pointer items-center justify-between text-left text-base sm:text-lg font-semibold text-gray-900 list-none">
                                {item.q}
                                <span className="ml-4 text-brand-600 transition-transform duration-200 group-open:rotate-45 text-2xl leading-none">+</span>
                            </summary>
                            <p className="mt-3 text-sm sm:text-base leading-7 text-gray-600">{item.a}</p>
                        </details>
                    ))}
                </div>
            </div>
        </div>
    )
}
